<template>
  <div :class="sidebarClasses" :data-background-color="backgroundColor" :data-active-color="activeColor">
    <div class="logo" @click="tablero">
      <a class="simple-text logo-mini">
        <div class="logo-img">
          <img :src="logo" alt="" class="">
        </div>
      </a>
      <!-- <a class="simple-text logo-normal" href="">
        {{ title }}
      </a> -->
      <h2 class=" simple-text logo-normal ml-3 m-0 ">
        <!-- {{ title }} -->
        <img src="static/img/background/declaranet_txt.png" alt="" class="dnet-txt">
      </h2>
    </div>
    <div class="sidebar-wrapper" ref="sidebarScrollArea">
      <ul :class="navClasses">
        <slot name="links">
          <sidebar-item v-for="(link, index) in sidebarLinks" :key="link.name + index" :link="link" class="ml-3 mt-3 mr-3 mw parent">
            <sidebar-item v-for="(subLink, index) in link.children" :key="subLink.name + index" :link="subLink" v-if="checaPermisos(subLink.permiso)" class="col-12 d-inline-block-flex p-2">
            </sidebar-item>
          </sidebar-item>
        </slot>
      </ul>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      title: {
        type: String,
        default: 'DeclaraNET 2019'
      },
      type: {
        type: String,
        default: 'sidebar',
        validator: (value) => {
          let acceptedValues = ['sidebar', 'navbar']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      backgroundColor: {
        type: String,
        default: 'white',
        validator: (value) => {
          let acceptedValues = ['white', 'brown', 'black']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      activeColor: {
        type: String,
        default: 'info',
        validator: (value) => {
          let acceptedValues = ['primary', 'info', 'success', 'warning', 'danger']
          return acceptedValues.indexOf(value) !== -1
        }
      },
      logo: {
        type: String,
        default: 'static/img/background/icon_logo.png'
      },
      sidebarLinks: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        visible: null,
        isClosed: true,
        permisos: []
      }
    },
    watch: {
      visible: function () {
        //console.log('--->', this.visible);
      },
      $sidebar: {
        handler: function (val, oldval) {
          //this.change = true;
          //console.log(this.$sidebar);
        },
        deep: true
      },
    },
    computed: {
      sidebarClasses() {
        if (this.type === 'sidebar') {
          return 'sidebar'
        } else {
          return 'collapse navbar-collapse off-canvas-sidebar'
        }
      },
      navClasses() {
        if (this.type === 'sidebar') {
          return 'nav'
        } else {
          return 'nav navbar-nav'
        }
      }
    },
    methods: {
      tablero() {
        console.log(this.getKey('role'));
        if (this.getKey('role') == '0') {
          this.$router.push('/forms/tablero');
        } else {
          this.$router.push('/admin/tablero');
        }
      },
      async initScrollBarAsync() {
        await import('perfect-scrollbar/dist/css/perfect-scrollbar.css')
        const PerfectScroll = await import('perfect-scrollbar')
        PerfectScroll.initialize(this.$refs.sidebarScrollArea)
      },
      cerrarSesion() {
        localStorage.clear();
        this.$router.push('/');
      },
      checaPermisos(permisoLink) {
        return this.permisos.some(r => permisoLink.includes(r))
      }
    },
    created() {},
    mounted() {
      this.initScrollBarAsync();
      this.visible = document.querySelector('.sidebar-normal'); //.querySelector('.sidebar-normal')
      //this.visible.style.opacity = 0;
      //console.log(this.$sidebar);
      // let grupo = 0
      let rol = 0
      let stats = 0
      let uid = 0
      let simplificada = '0'
      if (this.getKey('role') != 0) this.permisos = this.getKey('permisos')
      else {
        this.permisos = [1];
      }
      if (localStorage.getItem('app-token-declaranet')) {
        // grupo = this.getKey('grupo');
        simplificada = this.getKey('simplificada');
        rol = this.getKey('role');
        uid = this.getKey('uid');
        stats = this.getKey('status_dec');
        //console.log(stats)
        // console.log(rol)
      }
      let declaracion
      let menu;
      let declaraciones;
      let fiscal;
      let interes;
      /* let fiscal = [{
        name: 'Declaraciones',
        path: '/forms/fiscal',
        icon: 'fas fa-balance-scale',
        permiso: [1]
      }]; */

      let historial = [{
        name: 'Declaraciones',
        path: '/forms/historico',
        icon: 'fas fa-list',
        permiso: [1]
      }, {
        name: 'Aclaraciones',
        path: '/forms/aclaraciones',
        icon: 'fas fa-info',
        permiso: [1]
      }];


      if (stats == 1) {
        if (simplificada == '1') {
          declaracion = [{
            name: 'Información Personal',
            path: '/forms/infpersonal',
            permiso: [1],
            icon: 'fas fa-user-cog'
          }, {
            name: 'Intereses',
            path: '/forms/intereses',
            permiso: [1],
            icon: 'fas fa-file-invoice-dollar'
          }, {
            name: 'Ingresos',
            path: '/forms/ingresos',
            permiso: [1],
            icon: 'fas fa-dollar-sign'
          }];
        } else {
          declaracion = [{
            name: 'Información Personal',
            path: '/forms/infpersonal',
            icon: 'fas fa-user-cog',
            permiso: [1],
          }, {
            name: 'Intereses',
            path: '/forms/intereses',
            permiso: [1],
            icon: 'fas fa-file-invoice-dollar'
          }, {
            name: 'Ingresos',
            path: '/forms/ingresos',
            permiso: [1],
            icon: 'fas fa-dollar-sign'
          }, {
            name: 'Activos',
            path: '/forms/activos',
            permiso: [1],
            icon: 'fas fa-hand-holding-usd'
          }, {
            name: 'Pasivos',
            path: '/forms/pasivos',
            permiso: [1],
            icon: 'fas fa-money-bill'
          }, {
            name: 'Resumen',
            path: '/forms/resumen',
            icon: 'fas fa-file-invoice',
            permiso: [1],
          }];
        }
        declaraciones = [];
      } else {
        //si ya la envio
        declaracion = [{
          name: 'Enviada',
          path: '/forms/enviada',
          icon: 'fas fa-user-cog',
          permiso: [1],
        }];
        fiscal = [{
          name: 'Acuse de Declaración Fiscal',
          path: '/forms/fiscal',
          icon: 'fas fa-balance-scale',
          permiso: [1],
        }];
        interes = [{
          name: 'Manifestación de actualización de Conflicto de Intereses',
          path: '/forms/intereses',
          icon: 'fas fa-file-invoice-dollar',
          permiso: [1],
        }];
        declaraciones = [{
          name: 'Declaración 2019',
          path: '/forms/enviada',
          icon: 'fas fa-angle-right',
          permiso: [1],
        }]
      }
      if (rol != 0) { //si es administrador, mostrar menú completo
        if (uid == 89) {
          menu = [{
              name: 'Declaraciones',
              icon: 'ti-clipboard',
              collapsed: false,
              children: [{
                  name: 'Lista Declaraciones',
                  path: '/reportes/ldeclaraciones',
                  icon: 'fas fa-clipboard-list',
                  permiso: [1, 25]
                }, {
                  name: 'Historico Declaraciones',
                  path: '/reportes/hdecl',
                  icon: 'fas fa-history',
                  permiso: [1, 25]
                },
                // {
                //   name: 'Verificación',
                //   path: '/reportes/verificacion',
                //   icon: 'fas fa-check-double',
                //   permiso: [2]
                // },
                /* {
                           name: 'No de Declaraciones',
                           path: '/reportes/reporteDeclaraciones',
                           icon: 'fas fa-calendar',
                           permiso: [1]
                         }, */
              ]
            },
            {
              name: 'Padrón',
              icon: 'ti-agenda',
              collapsed: false,
              children: [{
                  name: 'Altas de personal',
                  path: '/admin/altapersonal',
                  icon: 'fas fa-user-plus',
                  permiso: [3]
                }, {
                  name: 'Movimientos',
                  path: '/admin/movimientos',
                  icon: 'fas fa-user-edit',
                  permiso: [4]
                }, {
                  name: 'Plantilla',
                  path: '/admin/plantilla',
                  icon: 'fas fa-file-excel',
                  permiso: [13]
                }, {
                  name: 'Plantilla de Ingresos',
                  path: '/admin/plantilla_ingresos',
                  icon: 'fas fa-file-excel',
                  permiso: [5]
                },
                {
                  name: 'Plantilla para bajas',
                  path: '/admin/plantilla_bajas',
                  icon: 'fas fa-file-excel',
                  permiso: [5, 13]
                }
              ]
            },

            {
              name: 'Procedimientos',
              icon: 'ti-write',
              collapsed: false,
              children: [{
                name: 'Casos omisos',
                path: '/reportes/omisos',
                icon: 'fas fa-eye-slash',
                permiso: [6, 21]
              }]
            },
            // {
            //   name: 'Act. Programadas',
            //   icon: 'ti-timer',
            //   collapsed: false,
            //   children: [{
            //     name: 'Activación Anual',
            //     path: '/admin/cronanual',
            //     icon: 'ti-loop',
            //     permiso: [27]
            //   }]
            // },
            {
              name: 'Configuración',
              icon: 'ti-settings',
              collapsed: false,
              children: [{
                name: 'Usuarios',
                path: '/admin/usuarios',
                icon: 'fas fa-users-cog',
                permiso: [8]
              }, {
                name: 'Permisos',
                path: '/admin/permisos',
                icon: 'fas fa-key',
                permiso: [9]
              }]
            }, {
              name: 'Reportes',
              icon: 'ti-printer',
              children: [{
                  name: 'Declaraciones',
                  path: '/reportes/declaraciones',
                  icon: 'fas fa-clipboard-list',
                  permiso: [10, 14]
                },
                {
                  name: 'Movimientos',
                  path: '/reportes/movimientos',
                  icon: 'fas fa-arrows-alt',
                  permiso: [11, 15]
                },
                {
                  name: 'Cumplimiento',
                  path: '/reportes/cumplimiento',
                  icon: 'fas fa-tasks',
                  permiso: [12, 16]
                },
                {
                  name: 'Reporte declaraciones',
                  path: '/reportes/RepDeclaraciones',
                  icon: 'fas fa-check-double',
                  permiso: [1]
                },
                {
                  name: 'No de Declaraciones',
                  path: '/reportes/reporteDeclaraciones2',
                  icon: 'fas fa-calendar',
                  permiso: [1]
                },
                {
                  name: 'Conflicto de Interés ',
                  path: '/reportes/reporteConflictoInt',
                  icon: 'fas fa-balance-scale',
                  permiso: [1]
                },
                {
                  name: 'Bajas por defunción ',
                  path: '/reportes/reporteBajasDefuncion',
                  icon: 'fas fa-archive',
                  permiso: [1]
                },
                {
                  name: 'Accesos a balanza',
                  path: '/reportes/reporteAccesosBalanza',
                  icon: 'fas fa-archive',
                  permiso: [1]
                }
              ]
            }
          ]
        } else
          menu = [{
              name: 'Declaraciones',
              icon: 'ti-clipboard',
              collapsed: false,
              children: [{
                  name: 'Lista Declaraciones',
                  path: '/reportes/ldeclaraciones',
                  icon: 'fas fa-clipboard-list',
                  permiso: [1, 25]
                }, {
                  name: 'Historico Declaraciones',
                  path: '/reportes/hdecl',
                  icon: 'fas fa-history',
                  permiso: [1, 25]
                },
                // {
                //   name: 'Verificación',
                //   path: '/reportes/verificacion',
                //   icon: 'fas fa-check-double',
                //   permiso: [2]
                // },
                /* {
                           name: 'No de Declaraciones',
                           path: '/reportes/reporteDeclaraciones',
                           icon: 'fas fa-calendar',
                           permiso: [1]
                         }, */
              ]
            }, {
              name: 'Padrón',
              icon: 'ti-agenda',
              collapsed: false,
              children: [{
                  name: 'Altas de personal',
                  path: '/admin/altapersonal',
                  icon: 'fas fa-user-plus',
                  permiso: [3]
                }, {
                  name: 'Movimientos',
                  path: '/admin/movimientos',
                  icon: 'fas fa-user-edit',
                  permiso: [4]
                }, {
                  name: 'Plantilla',
                  path: '/admin/plantilla',
                  icon: 'fas fa-file-excel',
                  permiso: [13]
                }, {
                  name: 'Plantilla de Ingresos',
                  path: '/admin/plantilla_ingresos',
                  icon: 'fas fa-file-excel',
                  permiso: [5]
                },
                /* {
                  name: 'Plantilla para bajas',
                  path: '/admin/plantilla_bajas',
                  icon: 'fas fa-file-excel',
                  permiso: [5, 13]
                } */
              ]
            },
            {
              name: 'Procedimientos',
              icon: 'ti-write',
              collapsed: false,
              children: [{
                name: 'Casos omisos',
                path: '/reportes/omisos',
                icon: 'fas fa-eye-slash',
                permiso: [6, 21]
              }]
            },
            {
              name: 'Act. Programadas',
              icon: 'ti-timer',
              collapsed: false,
              children: [{
                name: 'Activación Anual',
                path: '/admin/cronanual',
                icon: 'ti-loop',
                permiso: [27]
              }]
            },
            {
              name: 'Configuración',
              icon: 'ti-settings',
              collapsed: false,
              children: [{
                name: 'Usuarios',
                path: '/admin/usuarios',
                icon: 'fas fa-users-cog',
                permiso: [8]
              }, {
                name: 'Permisos',
                path: '/admin/permisos',
                icon: 'fas fa-key',
                permiso: [9]
              }]
            }, {
              name: 'Reportes',
              icon: 'ti-printer',
              children: [{
                  name: 'Declaraciones',
                  path: '/reportes/declaraciones',
                  icon: 'fas fa-clipboard-list',
                  permiso: [10, 14]
                },
                {
                  name: 'Movimientos',
                  path: '/reportes/movimientos',
                  icon: 'fas fa-arrows-alt',
                  permiso: [11, 15]
                },
                {
                  name: 'Cumplimiento',
                  path: '/reportes/cumplimiento',
                  icon: 'fas fa-tasks',
                  permiso: [12, 16]
                },
                {
                  name: 'Reporte declaraciones',
                  path: '/reportes/RepDeclaraciones',
                  icon: 'fas fa-check-double',
                  permiso: [1]
                },
                {
                  name: 'No de Declaraciones',
                  path: '/reportes/reporteDeclaraciones2',
                  icon: 'fas fa-calendar',
                  permiso: [1]
                },
                {
                  name: 'Conflicto de Interés ',
                  path: '/reportes/reporteConflictoInt',
                  icon: 'fas fa-balance-scale',
                  permiso: [26]
                },
                {
                  name: 'Bajas por defunción ',
                  path: '/reportes/reporteBajasDefuncion',
                  icon: 'fas fa-archive',
                  permiso: [1]
                },
                {
                  name: 'Accesos a balanza',
                  path: '/reportes/reporteAccesosBalanza',
                  icon: 'fas fa-archive',
                  permiso: [1]
                }
              ]
            }
          ]
      } else {
        menu = [
          /* {
                    name: 'Mis declaraciones',
                    icon: 'ti-layout-list-thumb',
                    children: declaraciones
                  },  */
          {
            name: 'Historial declaraciones',
            icon: 'ti-archive',
            children: historial
          }, {
            name: 'Declaración patrimonial',
            icon: 'ti-clipboard',
            children: declaracion
          }, {
            name: 'Declaración Fiscal',
            icon: 'ti-file',
            children: fiscal
          }, {
            name: 'Intereses',
            icon: 'ti-file',
            children: interes
          }, {
            name: 'Guía de llenado',
            path: this.$rootUrl + '/Guia.pdf',
            icon: 'far fa-file-pdf',
            target: '_blank',
            children: ''

          },
          {
            name: 'Guía rápida',
            path: 'https://www.powtoon.com/embed/fBmXjPtRPNP/',
            icon: 'fas fa-film',
            target: '_blank',
            children: ''

          },
        ];
      }
      this.$sidebar.sidebarLinks = menu;
    },
    updated() {
      //console.log(this.$sidebar);
    },
    beforeDestroy() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.showSidebar = false
      }
    }
  }

</script>
<style>
  @media (min-width: 992px) {

    .navbar-search-form-mobile,
    .nav-mobile-menu {
      display: none !important;
    }
  }

  .logo h2 {
    font-size: 15px !important;
  }

  .sidebar .logo,
  .off-canvas-sidebar .logo {
    padding: 15px 0px !important;
    cursor: pointer
  }

  .sidebar .logo .logo-img,
  .off-canvas-sidebar .logo .logo-img {
    width: 50px !important;
    position: relative !important;
    /* margin-bottom: 8px; */
    top: -5px !important;
  }

  .sidebar .logo a.logo-mini,
  .off-canvas-sidebar .logo a.logo-mini {
    width: 50px !important;
    margin-left: 15px !important;
  }

  .dnet-txt {
    height: 40px !important;
  }

  .sidebar .logo .logo-img img,
  .off-canvas-sidebar .logo .logo-img img {
    max-width: 50px !important;
    margin-bottom: 2px !important;
  }

  .mw {
    min-width: 200px !important;
  }

  .sidebar[data-active-color="info"] .nav li.parent.active>a {
    color: #fa625d !important;
  }

  .sidebar[data-active-color="info"] .nav li.active>a,
  .off-canvas-sidebar[data-active-color="info"] .nav li.active>a {
    color: #68B3C8 !important;
    opacity: 1;
  }

  .sidebar .nav li:not(.active)>a,
  .sidebar[data-background-color="white"] .nav li:not(.active)>a,
  .off-canvas-sidebar .nav li:not(.active)>a,
  .off-canvas-sidebar[data-background-color="white"] .nav li:not(.active)>a {
    color: #737373 !important;
  }

  /* .nav>li>a {
    position: initial !important;
  } */

</style>


// WEBPACK FOOTER //
// src/components/UIComponents/SidebarPlugin/SideBar.vue